import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupIntuneGroup } from "./intune";

const IntuneSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const IntuneSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const intuneScanners = (): Section => {
  const intuneScanners = new Section("intune_scanner", [
    new Translation("en", "Intune Scanners"),
    new Translation("en", "Intune-Scanner"),
  ]);
  intuneScanners.help = [
    new Translation(
      "en",
      `Add Intune to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie Intune hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];
  intuneScanners.description = [
    new Translation("en", IntuneSetupEn),
    new Translation("de", IntuneSetupDe),
  ];

  setupIntuneGroup(intuneScanners, 0);
  return intuneScanners;
};
